module.exports = __webpack_public_path__ + "static/communication-8fd93e71b78e47382f5dd7d86c82ce8f.png";